import { useState } from "react";
import { Offcanvas, OffcanvasBody } from "reactstrap";
import StepRecipient from "./StepRecipient";
import StepOptions from "./StepOptions";
import classnames from "classnames";
import Order from "~/model/order";

type TMobileContactModalProps = {
  order: Order;
  open: boolean;
  onToggle: () => void;
  onOpenChat: (channel: number) => void;
}

const MobileContactModal = ({ order, open, onToggle, onOpenChat }: TMobileContactModalProps) => {

  const [selectedPerson, setSelectedPerson] = useState<any>(null);

  const clearSelectedPerson = () => {
    setSelectedPerson(null);
  }

  return (
    <Offcanvas
      id="contact-modal"
      className={classnames("contact-offcanvas", { "expanded": !!selectedPerson })}
      isOpen={open}
      toggle={onToggle}
      onClosed={clearSelectedPerson}
      direction="bottom"
    >
      <OffcanvasBody>
        <div className="line" />
        {!selectedPerson && <StepRecipient order={order} selectPerson={(person: any) => setSelectedPerson(person)} onOpenChat={onOpenChat} />}
        {!!selectedPerson && <StepOptions selectedPerson={selectedPerson} onOpenChat={onOpenChat} personRoleLabel={'Contact your '} />}
      </OffcanvasBody>
    </Offcanvas>
  );
}

export default MobileContactModal;